import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import UseCaseDetailsFrame from 'src/components/use-case-details-frame'
import PillButton from 'src/components/pill-button'
import TextButton from 'src/components/text-button'
import TapAnimation from 'src/components/tap-animation'
import PhoneContainer from 'src/components/phone-container'
import content1Src from 'src/assets/use-case-1-content-1.png'
import content2Src from 'src/assets/use-case-1-content-2.png'
import content3Src from 'src/assets/use-case-1-content-3.png'
import content4Src from 'src/assets/use-case-1-content-4.png'
import content5Src from 'src/assets/use-case-1-content-5.png'

export class UseCase1Frame1 extends Component {
  static propTypes = {
    className: PropTypes.string,
    useCase: PropTypes.object.isRequired,
    back: PropTypes.func.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-1-frame-1', className)
  }

  state = {
    contentId: 'content-1',
    shouldTap1: false,
    shouldTap3a: false,
    shouldTap3b: false,
    shouldTap4: false,
    onTapComplete: () => {},
  }

  render() {
    const { className } = this
    const { useCase, back } = this.props
    const { contentId, onTapComplete, shouldTap1, shouldTap3a, shouldTap3b, shouldTap4 } = this.state
    const { content1, content2, content3, content4, content5 } = useCase
    return (
      <UseCaseDetailsFrame className={className} back={back} useCase={useCase} type="phone">
        <section className={c('content content-1', contentId === 'content-1' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h3>{content1.copy1}</h3>
              <h2>{content1.copy2}</h2>
            </section>
            <section className="pill-buttons">
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap1: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap1: false, contentId: 'content-2' })
                    },
                  })
                }}>
                {content1.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap1: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap1: false, contentId: 'content-3' })
                    },
                  })
                }}>
                {content1.button2}
              </PillButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content1Src}>
              <TapAnimation className="tap-1" shouldTap={shouldTap1} onTapComplete={onTapComplete} />
            </PhoneContainer>
          </section>
        </section>
        <section className={c('content content-2', contentId === 'content-2' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content2.copy1}</h2>
              <p>{content2.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content2.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content2Src} />
          </section>
        </section>
        <section className={c('content content-3', contentId === 'content-3' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content3.copy1}</h2>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap3a: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap3a: false, contentId: 'content-4' })
                    },
                  })
                }}>
                {content3.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap3b: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap3b: false, contentId: 'content-5' })
                    },
                  })
                }}>
                {content3.button2}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content3.button3}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content3Src}>
              <TapAnimation className="tap-3-a" shouldTap={shouldTap3a} onTapComplete={onTapComplete} />
              <TapAnimation className="tap-3-b" shouldTap={shouldTap3b} onTapComplete={onTapComplete} />
            </PhoneContainer>
          </section>
        </section>
        <section className={c('content content-4', contentId === 'content-4' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content4.copy1}</h2>
              <p>{content4.copy2}</p>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap4: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap4: false, contentId: 'content-2' })
                    },
                  })
                }}>
                {content4.button1}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-3' })}>
                {content4.button2}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content4Src}>
              <TapAnimation className="tap-4" shouldTap={shouldTap4} onTapComplete={onTapComplete} />
            </PhoneContainer>
          </section>
        </section>
        <section className={c('content content-5', contentId === 'content-5' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content5.copy1}</h2>
              <p>{content5.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content5.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <PhoneContainer src={content5Src} />
          </section>
        </section>
      </UseCaseDetailsFrame>
    )
  }
}

export default UseCase1Frame1
